import { Button, Flex, Popup, Spacing, Text } from '@approvalmax/ui/src/components';
import { useSelector } from 'modules/react-redux';
import { memo } from 'react';

import { OPTIMISTIC_LOCKING_POPUP } from '../../../reducers/page/activePopup/optimisticLockingPopupReducer';
import { getActivePopupId } from '../../../selectors/pageSelectors';
import { messages } from './OptimisticLockingPopup.messages';
import { OptimisticLockingPopupProps } from './OptimisticLockingPopup.types';

export const OptimisticLockingPopup = memo<OptimisticLockingPopupProps>((props) => {
    const { onOverwriteRequest, onClose } = props;

    const activePopupId = useSelector(getActivePopupId);

    return (
        <Popup closable={false} open={activePopupId === OPTIMISTIC_LOCKING_POPUP} size='small'>
            <Popup.Header title={messages.title} />

            <Popup.Body spacing='32'>
                <Text font='body' fontSize='medium'>
                    {messages.description}
                </Text>

                <Spacing height={32} />

                <Flex spacing='32' justifyContent='end'>
                    <Button onClick={onOverwriteRequest} color='red40' size='large'>
                        {messages.buttonOverwrite}
                    </Button>

                    <Button onClick={onClose} color='blue80' size='large'>
                        {messages.buttonCancel}
                    </Button>
                </Flex>
            </Popup.Body>
        </Popup>
    );
});

OptimisticLockingPopup.displayName = 'OptimisticLockingPopup';
